import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { getDownloadURL, ref, uploadBytes } from "firebase/storage";

import { v4 } from "uuid";

import { storage } from "../../firebase";
import apiServices from "../../services/apiServices";

// First, create the thunk
export const fetchAllProduct = createAsyncThunk(
  "product_state/fetchAllProduct",
  async () => {
    const response = await apiServices.get("products");
    console.log("product..", response.data.data);

    return response.data.data;
  }
);
export const fetchFilterProduct = createAsyncThunk(
  "product_state/fetchFilterProduct",
  async (filters) => {
    const response = await apiServices.post("products/filters", filters);
    console.log("product..", response.data.data);

    return response.data.data;
  }
);
export const updateProduct = createAsyncThunk(
  "product_state/updateProduct",
  async (data) => {
    console.log("update pro data", data);
    console.log("update data[0]._id", data[0]._id);
    try {
      const response = await apiServices.put("product/" + data[0]._id, data[0]);

      return response.data.data;
    } catch (error) {
      console.log("update error ", error);
      throw error;
    }
  }
);
export const addProduct = createAsyncThunk(
  "product_state/addProduct",
  async (data) => {
    const response = await apiServices.post("product", data);
    console.log(response.data.data);
    return response.data.data;
  }
);
export const uploadImages = createAsyncThunk(
  "product_state/uploadImages",
  async (imgFile) => {
    const imgName = "images/" + v4() + imgFile.name;
    console.log("img uploading...", imgName);
    const imgRef = ref(storage, imgName);

    const d = await uploadBytes(imgRef, imgFile)
      .then(async (snapshot) => {
        const url = await getDownloadURL(snapshot.ref);

        return url;
      })
      .catch((err) => console.log(err));
    console.log("url", d);
    return d; //normal upload
  }
);
export const uploadNewImages = createAsyncThunk(
  "product_state/uploadNewImages",
  async (imgFile) => {
    const imgName = "images/" + v4() + imgFile.name;
    console.log("img uploading...", imgName);
    const imgRef = ref(storage, imgName);

    const d = await uploadBytes(imgRef, imgFile)
      .then(async (snapshot) => {
        const url = await getDownloadURL(snapshot.ref);

        return url;
      })
      .catch((err) => console.log(err));
    console.log("url", d);
    return d; //normal upload
  }
);

const initialState = {
  products: [],
  filteredproducts: [],
  productAdded: false,
  errorMessage: "",
  successMessage: "",
  uploading: false,
  loading: false,
  stepOne: {
    title: "",
    description: "",
    date: "",
    clarity: "",
    type: "",
    need_recut: "",
    treatment_type: "",
    origin: "",
    shape: "",
    weight: 0.0,
    dimension: "",
    dimensionHeight: 0,
    dimensionWidth: 0,
    dimensionDepth: 0,
    category: "",
  },
  stepTwo: {
    buyCurrency: "LKR",
    buyPrice: "0",
    sellPriceLocal: "0",
    sellLocalCurrency: "LKR",
    sellForeignersCurrency: "USD",
    sellPriceForeigners: "0",
    supplier: "",
    supplierId: "",

    sellPriceLocal2: "",
    sellPriceForeigners2: "",
    exchangeRate: "360",
    buyPiece: "1",
    priceVariant: false,
  },
  exportDetails: {
    exportMainCategory: "",
    exportWeightRange: "",
  },
  stepThree: {
    customer: "",
  },
  stepFour: {
    images: [],
    imagesUrl: [],
    videosUrl: [],
    videos: [],
  },
  ItemStorage:{
    storageBoxName:"",
    storageSlot:"",
    storageBoxColumnSize:"",
    storageBoxRowSize :"",
  },
  editProduct: {
    loading: false,
    errorMessage: "",
    productEdited: false,

    successMessage: "",
    uploading: false,

    stepOne: {
      _id: "",
      productId: "",
      title: "",
      description: "",
      date: "",
      clarity: "",
      type: "",
      need_recut: "",
      treatment_type: "",
      origin: "",
      shape: "",
      weight: 0.0,
      dimension: "",
      dimensionHeight: 0,
      dimensionWidth: 0,
      dimensionDepth: 0,
      category: "",
    },
    stepTwo: {
      buyCurrency: "LKR",
      buyPrice: "0",
      sellPriceLocal: "0",
      sellLocalCurrency: "LKR",
      sellForeignersCurrency: "USD",
      sellPriceForeigners: "0",
      supplier: "",
      supplierId: "",

      sellPriceLocal2: "",
      sellPriceForeigners2: "",
      exchangeRate: "360",
      buyPiece: "1",
      priceVariant: false,
    },
    exportDetails: {
      exportMainCategory: "",
      exportWeightRange: "",
    },
    stepThree: {
      customer: "",
    },
    stepFour: {
      images: [],
      imagesUrl: [],
      videosUrl: [],
      videos: [],
    },
    ItemStorage:{
      storageBoxName:"",
      storageSlot:"",
      storageBoxColumnSize:"",
      storageBoxRowSize :"",
    },
  },
  error: "",
};

const resetState = {
  products: [],
  productAdded: false,
  stepOne: {
    title: "",
    description: "",
    date: "",
    clarity: "",
    type: "",
    need_recut: "No",
    treatment_type: "Heated",
    origin: "",
    shape: "",
    weight: 0.0,
    dimension: "",
    dimensionHeight: 0,
    dimensionWidth: 0,
    dimensionDepth: 0,
    category: "Precious",
  },

  stepTwo: {
    buyCurrency: "LKR",
    buyPrice: "0",
    sellPriceLocal: "0",
    sellLocalCurrency: "LKR",
    sellForeignersCurrency: "USD",
    sellPriceForeigners: "0",
    supplier: "",
    supplierId: "",

    sellPriceLocal2: "",
    sellPriceForeigners2: "",
    exchangeRate: "360",
    buyPiece: "1",
    priceVariant: false,
  },

  stepThree: {
    customer: "",
  },
  stepFour: {
    images: [],
    imagesUrl: [],
    videosUrl: [],
    videos: [],
  },
  error: "",
  exportDetails: {
    exportMainCategory: "",
    exportWeightRange: "",
  },
  ItemStorage:{
    storageBoxName:"",
    storageSlot:"",
    storageBoxColumnSize:"",
    storageBoxRowSize :"",
  },

  editProduct: {
    loading: false,
    errorMessage: "",
    stepOne: {
      _id: "",
      productId: "",
      title: "",
      description: "",
      date: "",
      clarity: "",
      type: "",
      need_recut: "",
      treatment_type: "",
      origin: "",
      shape: "",
      weight: 0.0,
      dimension: "",
      dimensionHeight: 0,
      dimensionWidth: 0,
      dimensionDepth: 0,
      category: "",
    },
    stepTwo: {
      buyCurrency: "LKR",
      buyPrice: "0",
      sellPriceLocal: "0",
      sellLocalCurrency: "LKR",
      sellForeignersCurrency: "USD",
      sellPriceForeigners: "0",
      supplier: "",
      supplierId: "",

      sellPriceLocal2: "",
      sellPriceForeigners2: "",
      exchangeRate: "",
      buyPiece: "1",
      priceVariant: false,
    },
    exportDetails: {
      exportMainCategory: "",
      exportWeightRange: "",
    },
    stepThree: {
      customer: "",
    },
    stepFour: {
      images: [],
      imagesUrl: [],
      videosUrl: [],
      videos: [],
    },
    ItemStorage:{
      storageBoxName:"",
      storageSlot:"",
      storageBoxColumnSize:"",
      storageBoxRowSize :"",
    },
  },
};

let productSlice = createSlice({
  name: "product_state",
  initialState,
  reducers: {
    // insert actions here
    resetUploadState: (state, action) => {
      state.loading = false;
      state.uploading = false;
      state.successMessage = "";
    },
    addStepOne: function (state, action) {
      console.log("ad Step one", action.payload);
      if (!action.payload) return;
      const {
        title,
        description,
        date,
        clarity,
        need_recut,
        treatment_type,
        origin,
        shape,
        weight,
        dimension,
        category,
        dimensionHeight,
        dimensionWidth,
        dimensionDepth,
      } = action.payload;

      state.stepOne.title = title;
      state.stepOne.description = description;

      state.stepOne.date = date;
      state.stepOne.clarity = clarity;
      state.stepOne.need_recut = need_recut;
      state.stepOne.treatment_type = treatment_type;
      state.stepOne.origin = origin;
      state.stepOne.shape = shape;
      state.stepOne.weight = weight; //parseFloat().toFixed(2);
      state.stepOne.category = category;
      state.stepOne.dimensionDepth = Number(dimensionDepth);
      state.stepOne.dimensionWidth = Number(dimensionWidth);
      state.stepOne.dimensionHeight = Number(dimensionHeight);

      console.log("product one entry", action.payload);
    },
    addEditStepOne: function (state, action) {
      console.log("ad Step one", action.payload);
      if (!action.payload) return;
      const {
        _id,
        productId,
        title,
        description,
        date,
        clarity,
        need_recut,
        treatment_type,
        origin,
        shape,
        weight,
        dimension,
        category,
        dimensionHeight,
        dimensionWidth,
        dimensionDepth,
      } = action.payload;
      state.editProduct.stepOne._id = _id;
      state.editProduct.stepOne.productId = productId;
      state.editProduct.stepOne.title = title;
      state.editProduct.stepOne.description = description;

      state.editProduct.stepOne.date = date;
      state.editProduct.stepOne.clarity = clarity;
      state.editProduct.stepOne.need_recut = need_recut;
      state.editProduct.stepOne.treatment_type = treatment_type;
      state.editProduct.stepOne.origin = origin;
      state.editProduct.stepOne.shape = shape;
      state.editProduct.stepOne.weight = parseFloat(weight).toFixed(2);
      state.editProduct.stepOne.category = category;
      state.editProduct.stepOne.dimensionDepth = Number(dimensionDepth);
      state.editProduct.stepOne.dimensionWidth = Number(dimensionWidth);
      state.editProduct.stepOne.dimensionHeight = Number(dimensionHeight);

      console.log("product edit one entry", action.payload);
    },
    addStepTwo: function (state, action) {
      const {
        buyCurrency,
        buyPrice,
        sellPriceLocal,
        sellLocalCurrency,
        sellForeignersCurrency,
        sellPriceForeigners,
        sellPriceLocal2,
        sellPriceForeigners2,
        exchangeRate,
        buyPiece,
        priceVariant,
      } = action.payload;

      state.stepTwo.buyCurrency = buyCurrency;
      state.stepTwo.buyPrice = buyPrice;
      state.stepTwo.sellPriceLocal = sellPriceLocal;
      state.stepTwo.sellLocalCurrency = sellLocalCurrency;
      state.stepTwo.sellForeignersCurrency = sellForeignersCurrency;
      state.stepTwo.sellPriceForeigners = sellPriceForeigners;

      state.stepTwo.sellPriceLocal2 = sellPriceLocal2;
      state.stepTwo.sellPriceForeigners2 = sellPriceForeigners2;
      state.stepTwo.exchangeRate = exchangeRate;
      state.stepTwo.buyPiece = buyPiece;
      state.stepTwo.priceVariant = priceVariant;

      console.log("product stepTwo entry", action.payload);
    },
    addEditStepTwo: function (state, action) {
      const {
        buyCurrency,
        buyPrice,
        sellPriceLocal,
        sellLocalCurrency,
        sellForeignersCurrency,
        sellPriceForeigners,
        sellPriceLocal2,
        sellPriceForeigners2,
        exchangeRate,
        buyPiece,
        priceVariant,
      } = action.payload;
 

      state.editProduct.stepTwo.buyCurrency = buyCurrency;
      state.editProduct.stepTwo.buyPrice = buyPrice;
      state.editProduct.stepTwo.sellPriceLocal = sellPriceLocal;
      state.editProduct.stepTwo.sellLocalCurrency = sellLocalCurrency;
      state.editProduct.stepTwo.sellForeignersCurrency = sellForeignersCurrency;
      state.editProduct.stepTwo.sellPriceForeigners = sellPriceForeigners;

      state.editProduct.stepTwo.sellPriceLocal2 = sellPriceLocal2;
      state.editProduct.stepTwo.sellPriceForeigners2 = sellPriceForeigners2;
      state.editProduct.stepTwo.exchangeRate = exchangeRate;
      state.editProduct.stepTwo.buyPiece = buyPiece;
      state.editProduct.stepTwo.priceVariant = priceVariant;

      console.log("product edit stepTwo entry", action.payload);
    },

    addItemStorage: function (state, action) {
      const {storageBoxName, storageSlot , storageBoxRowSize ,storageBoxColumnSize } = action.payload;

     
      state.ItemStorage.storageBoxName = storageBoxName;
      state.ItemStorage.storageSlot = storageSlot;
      state.ItemStorage.storageBoxRowSize= storageBoxRowSize;
      state.ItemStorage.storageBoxColumnSize= storageBoxColumnSize;
        
    },
    addItemStorage_Edit: function (state, action) {
      const {storageBoxName, storageSlot , storageBoxRowSize ,storageBoxColumnSize } = action.payload;

     
      state.editProduct.ItemStorage.storageBoxName = storageBoxName;
      state.editProduct.ItemStorage.storageSlot = storageSlot;
      state.editProduct.ItemStorage.storageBoxRowSize= storageBoxRowSize;
      state.editProduct.ItemStorage.storageBoxColumnSize= storageBoxColumnSize;
        
    },
    addExportDetails: function (state, action) {
      const { exportMainCategory, exportWeightRange } = action.payload;

      // console.log("action.payload.exportDetails", action.payload);
      state.exportDetails.exportMainCategory = exportMainCategory;
      state.exportDetails.exportWeightRange =
        Number(state.stepOne.weight) >= 3.0 ? "Big (+3)" : "Small (-3)";
    },
    addEditExportDetails: function (state, action) {
      const { exportMainCategory, exportWeightRange } = action.payload;

      // console.log("action.payload.exportDetails", action.payload);
      state.editProduct.exportDetails.exportMainCategory = exportMainCategory;
      state.editProduct.exportDetails.exportWeightRange =
        Number(state.editProduct.stepOne.weight) >= 3.0 ? "Big (+3)" : "Small (-3)";
    },
    addStepTwoSupplier: function (state, action) {
      console.log("action.payload.addStepTwoSupplier", action.payload);
      state.stepTwo.supplier = action.payload;
    },
    editStepTwoSupplier: function (state, action) {
      console.log("action.payload.addStepTwoSupplier", action.payload);
      state.editProduct.stepTwo.supplier = action.payload;
    },

    addStepThree: function (state, action) {
      console.log("action.payload.customer", action.payload);
      state.stepThree.customer = action.payload;
    },
    editStepThree: function (state, action) {
      console.log("action.payload.customer", action.payload);
      state.editProduct.stepThree.customer = action.payload;
    },
    updateImages: function (state, action) {
      const imgs = action.payload.images;

      const videos = action.payload.videos;
      state.updateImages.images = imgs;
      state.updateImages.videos = videos;
    },
    resetImages: function (state, action) {
      state.updateImages.images = [];
      state.updateImages.videos = [];
    },
    addStepFour: function (state, action) {
      const imgs = action.payload.images;

      const videos = action.payload.videos;
      state.stepFour.images = imgs;
      state.stepFour.videos = videos;
    },
    addEditStepFour: function (state, action) {
      const imgs = action.payload.images;

      const videos = action.payload.videos;
      state.editProduct.stepFour.images = imgs;
      state.editProduct.stepFour.videos = videos;
    },
    editStepFour: function (state, action) {
      const imgs = action.payload.imagesUrl;
      const videos = action.payload.videosUrl;

      state.editProduct.stepFour.imagesUrl = imgs;
      state.editProduct.stepFour.videosUrl = videos;

      console.log("editStep4", imgs)
    },
    editStepFourTempImage: function (state, action) {
      const imgs = action.payload.images;
      const videos = action.payload.videos;

      state.editProduct.stepFour.images = imgs;
      state.editProduct.stepFour.videos = videos;
    },
    resetImagesAfterUpload_EditMod: function (state, action) {
      state.editProduct.stepFour.images = [];
      state.editProduct.stepFour.videos = [];
    },
    reset: function (state, action) {
      state.productAdded = false;
      state.errorMessage = "";
      state.successMessage = "";
      state.uploading = false;
      state.loading = false;
      state.stepOne = resetState.stepOne;
      state.stepTwo = resetState.stepTwo;
      state.stepThree = resetState.stepThree;
      state.stepFour = resetState.stepFour;
      state.exportDetails = resetState.exportDetails;
      state.ItemStorage = resetState.ItemStorage;

      console.log("reset all ", state.stepOne)
    },
    resetEdit: function (state, action) {
      state.editProduct.productEdited = false;
      state.editProduct.errorMessage = "";
      state.editProduct.successMessage = "";
      state.editProduct.uploading = false;
      state.editProduct.loading = false;
    },
    editProductInitialization: function (state, action) {
      // state.editProduct = action.payload;
      console.log("state.editProduct", action.payload);
      //step one
      const {
        _id,
        productId,
        title,
        description,
        date,
        clarity,
        need_recut,
        treatment_type,
        origin,
        shape,
        weight,
        dimension,
        category,
        dimensionHeight,
        dimensionWidth,
        dimensionDepth,

        buyCurrency,
        buyPrice,
        sellPriceLocal,
        sellLocalCurrency,
        sellForeignersCurrency,
        sellPriceForeigners,
        supplier,

        customer,

        images,
        videos,
        ItemStorage
      
      } = action.payload;

      state.editProduct.stepOne._id = _id;
      state.editProduct.stepOne.productId = productId;
      state.editProduct.stepOne.title = title;
      state.editProduct.stepOne.description = description;

      state.editProduct.stepOne.date = date;
      state.editProduct.stepOne.clarity = clarity;
      state.editProduct.stepOne.need_recut = need_recut;
      state.editProduct.stepOne.treatment_type = treatment_type;
      state.editProduct.stepOne.origin = origin;
      state.editProduct.stepOne.shape = shape;
      state.editProduct.stepOne.weight = parseFloat(weight).toFixed(2);
      state.editProduct.stepOne.category = category;
      state.editProduct.stepOne.dimensionDepth = Number(dimensionDepth);
      state.editProduct.stepOne.dimensionWidth = Number(dimensionWidth);
      state.editProduct.stepOne.dimensionHeight = Number(dimensionHeight);

      //step two

      state.editProduct.stepTwo.buyCurrency = buyCurrency;
      state.editProduct.stepTwo.buyPrice = buyPrice;
      state.editProduct.stepTwo.sellPriceLocal = sellPriceLocal;
      state.editProduct.stepTwo.sellLocalCurrency = sellLocalCurrency;
      state.editProduct.stepTwo.sellForeignersCurrency = sellForeignersCurrency;
      state.editProduct.stepTwo.sellPriceForeigners = sellPriceForeigners;
      state.editProduct.stepTwo.supplier = supplier;

      //step three
      state.editProduct.stepThree.customer = customer;

      //step four
      state.editProduct.stepFour.imagesUrl = images;
      state.editProduct.stepFour.videosUrl = videos;
      //step storageBox
      state.editProduct.ItemStorage = ItemStorage;
      // state.editProduct.ItemStorage.storageBoxName = storageBoxName;
      // state.editProduct.ItemStorage.storageSlot = storageSlot;
      // state.editProduct.ItemStorage.storageBoxColumnSize = storageBoxColumnSize;
      // state.editProduct.ItemStorage.storageBoxRowSize = storageBoxRowSize;
       
      

      console.log("addEditStepFour ", state.editProduct);
    },
  },
  extraReducers: (builder) => {
    // Add reducers for additional action types here, and handle loading state as needed
    builder.addCase(fetchAllProduct.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(fetchAllProduct.fulfilled, (state, action) => {
      // Add user to the state array
      console.log("product fetching: ", action.payload);
      let productsArr = [];
      action.payload &&
        action.payload.map((x) => {
          let singleProduct = {
            id: x._id,
            productId: x.productId,
            title: x.title,
            description: x.description,
            category: x.category,

            date: x.date,
            clarity: x.clarity,
            need_recut: x.need_recut,
            treatment_type: x.treatment_type,
            origin: x.origin,
            shape: x.shape,
            weight: parseFloat(x.weight).toFixed(2),

            dimension:
              x.dimensionHeight +
              "*" +
              x.dimensionWidth +
              "*" +
              x.dimensionDepth,
            dimensionHeight: x.dimensionHeight,
            dimensionWidth: x.dimensionWidth,
            dimensionDepth: x.dimensionDepth,
            buyCurrency: x.buyCurrency,
            buyPrice: x.buyPrice,
            sellPriceLocal: x.sellPriceLocal,
            sellLocalCurrency: x.sellLocalCurrency,
            sellForeignersCurrency: x.sellForeignersCurrency,
            sellPriceForeigners: x.sellPriceForeigners,
            supplier: x.supplier,
            isSold: x?.isSold,
            invoiceNumber: x?.invoiceNumber,
            customer: x.customer,
            images: x.images,
            videos: x.videos,
            productStatus: x.productStatus,
            createdDate: x.createdDate,

            sellPriceLocal2: x.sellPriceLocal2,
            sellPriceForeigners2: x.sellPriceForeigners2,
            priceVariant: x.priceVariant,
            buyPiece: x.buyPiece,
            exchangeRate: x?.exchangeRate,

            exportMainCategory: x?.exportMainCategory,
            exportWeightRange: x?.exportWeightRange,

            storageBoxName:x?.storageBoxName,
            storageSlot: x?.storageSlot,

            
          };
          console.log("storageSlot", singleProduct.storageSlot)
          return productsArr.push(singleProduct);
        });
      state.products = productsArr;
      state.loading = false;
    });
    builder.addCase(fetchAllProduct.rejected, (state, action) => {
      state.loading = false;

      state.errorMessage = "Oops !, server error in fetching product";
    });

    //upload images
    builder.addCase(uploadImages.pending, (state, action) => {
      state.loading = true;
      state.uploading = true;
    });
    builder.addCase(uploadImages.fulfilled, (state, action) => {
      // Add user to the state array
      console.log("upload payload : ", action.payload);
      state.editProduct.stepFour.imagesUrl = [
        ...state.editProduct.stepFour.imagesUrl,
        action.payload,
      ];

      
      state.loading = false;
      state.uploading = false;

      state.successMessage = "Image Upload Successfully";
    });
    builder.addCase(uploadImages.rejected, (state, action) => {
      state.loading = false;
      state.uploading = false;
      state.errorMessage = "Oops !, server error in uploading images";
    });

    //upload images
    builder.addCase(uploadNewImages.pending, (state, action) => {
      state.loading = true;
      state.uploading = true;
    });
    builder.addCase(uploadNewImages.fulfilled, (state, action) => {
      // Add user to the state array
      console.log("upload payload : ", action.payload);
      state.stepFour.imagesUrl = [...state.stepFour.imagesUrl, action.payload];

      state.loading = false;
      state.uploading = false;

      state.successMessage = "Image Upload Successfully";
    });
    builder.addCase(uploadNewImages.rejected, (state, action) => {
      state.loading = false;
      state.uploading = false;
      state.errorMessage = "Oops !, server error in uploading images";
    });
    //upload images
    builder.addCase(fetchFilterProduct.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(fetchFilterProduct.fulfilled, (state, action) => {
      if (action.payload && action.payload.length !== 0) {
        action.payload.map((x) => {
          x.weight = parseFloat(x.weight).toFixed(2);
          console.log(
            "fetchFilterProduct product images : ",
            x.productId,
            x.images
          );
          return x;
        });
        // action.payload = arr
      }
      state.filteredproducts = action.payload;
      state.loading = false;
    });
    builder.addCase(fetchFilterProduct.rejected, (state, action) => {
      state.loading = false;
      state.errorMessage = "Oops !, server error in fetch Filter Product";
    });

    // add all product
    builder.addCase(addProduct.pending, (state, action) => {
      state.loading = true;
      state.productAdded = false;
    });
    builder.addCase(addProduct.fulfilled, (state, action) => {
      // Add user to the state array
      let singleProduct = {
        id: action.payload._id,
        category: action.payload.category,
        title: action.payload.title,
        description: action.payload.description,

        date: action.payload.date,
        clarity: action.payload.clarity,
        need_recut: action.payload.need_recut,
        treatment_type: action.payload.treatment_type,
        origin: action.payload.origin,
        shape: action.payload.shape,
        weight: parseFloat(action.payload.weight).toFixed(2),
        dimension: action.payload.dimension,
        buyCurrency: action.payload.buyCurrency,
        sellPriceLocal: action.payload.sellPriceLocal,
        sellLocalCurrency: action.payload.sellLocalCurrency,
        sellForeignersCurrency: action.payload.sellForeignersCurrency,
        sellPriceForeigners: action.payload.sellPriceForeigners,
        supplier: action.payload.supplier,

        sellPriceLocal2: action.payload.sellPriceLocal2,
        sellPriceForeigners2: action.payload.sellPriceForeigners2,
        priceVariant: action.payload.priceVariant,
        buyPiece: action.payload.buyPiece,
        exchangeRate: action.payload?.exchangeRate,

        exportMainCategory: action.payload?.exportMainCategory,
        exportWeightRange: action.payload?.exportWeightRange,

        customer: action.payload.customer,
        images: action.payload.images,
        videos: action.payload.videos,
        productStatus: action.payload.productStatus,

        storageBoxName: action.payload.storageBoxName,
        storageSlot: action.payload.storageSlot,
      };
      state.products = [...state.products, singleProduct];
      state.loading = false;
      state.productAdded = true;
      state.stepOne = resetState.stepOne;
      state.stepTwo = resetState.stepTwo;
      state.stepThree = resetState.stepThree;
      state.stepFour = resetState.stepFour;
      state.exportDetails = resetState.exportDetails;
      state.ItemStorage = resetState.ItemStorage;
      state.successMessage = "New Item Saved Successfully";
    });
    builder.addCase(addProduct.rejected, (state, action) => {
      state.loading = false;
      state.productAdded = false;
      state.errorMessage = "Oops !, server error in adding product";
      console.log(state.errorMessage);
    });
    // edit all product
    builder.addCase(updateProduct.pending, (state, action) => {
      state.loading = true;
      state.productEdited = false;
    });
    builder.addCase(updateProduct.fulfilled, (state, action) => {
      // Add user to the state array
      let singleProduct = {
        id: action.payload._id,
        category: action.payload.category,
        title: action.payload.title,
        description: action.payload.description,
        productId: action.payload.productId,
        date: action.payload.date,
        clarity: action.payload.clarity,
        need_recut: action.payload.need_recut,
        treatment_type: action.payload.treatment_type,
        origin: action.payload.origin,
        shape: action.payload.shape,
        weight: parseFloat(action.payload.weight).toFixed(2),
        dimension: action.payload.dimension,
        buyCurrency: action.payload.buyCurrency,
        sellPriceLocal: action.payload.sellPriceLocal,
        sellLocalCurrency: action.payload.sellLocalCurrency,
        sellForeignersCurrency: action.payload.sellForeignersCurrency,
        sellPriceForeigners: action.payload.sellPriceForeigners,
        supplier: action.payload.supplier,

        customer: action.payload.customer,
        images: action.payload.images,
        videos: action.payload.videos,
        productStatus: action.payload.productStatus,

        //storage
        storageBoxName: action.payload.storageBoxName,
        storageSlot: action.payload.storageSlot,

      };
      let old_state = state.products.filter((x) => x.id !== singleProduct.id); // removed old product
      console.log("old_state ", old_state);
      let newState = [...old_state, singleProduct];
      state.products = newState; //adding new product
      console.log("newState ", newState);
      state.editProduct.loading = false;
      state.editProduct.productEdited = true;
      state.editProduct.successMessage = "Item Details Edited Successfully ";

      state.editProduct.stepOne = resetState.editProduct.stepOne;
      state.editProduct.stepTwo = resetState.editProduct.stepTwo;
      state.editProduct.stepThree = resetState.editProduct.stepThree;
      state.editProduct.stepFour = resetState.editProduct.stepFour;
      state.editProduct.ItemStorage = resetState.editProduct.ItemStorage;
    });
    builder.addCase(updateProduct.rejected, (state, action) => {
      state.editProduct.loading = false;
      state.editProduct.productEdited = true;

      console.log("action : ", action);
      const CustomError = {
        name: "Custom API Error",
        message: action?.error?.message,
        // data: JSON.stringify(action?.error?.response?.data) // Serializable
      };
      state.editProduct.errorMessage = CustomError.message
        ? CustomError.message
        : "Oops !, server error in updating product, contact support";

      console.log("CustomError : ", CustomError);
    });
  },
});
export const {
  addItemStorage,
  addItemStorage_Edit,
  resetUploadState,
  resetImagesAfterUpload_EditMod,
  addExportDetails,
  addEditExportDetails,
  resetEdit,
  reset,
  editProductInitialization,
  addStepOne,
  addEditStepOne,
  addStepTwo,
  addEditStepTwo,
  addStepTwoSupplier,
  editStepTwoSupplier,
  addStepThree,
  editStepThree,
  addStepFour,
  addEditStepFour,
  editStepFour,
  editStepFourTempImage,
  updateImages,
  resetImages,
} = productSlice.actions;
export default productSlice.reducer;
